import { AuthFooter } from "../../../components/Footer/AuthFooter.jsx";
import { ResetPasswordForm } from "../../../components/Form/ResetPasswordForm.js";
import { SignNav } from "../../../components/Navbar/Webpages/AuthNav";

const ResetPassword = () => {
  return (
    <div className="flex flex-col h-screen">
      <SignNav />
      <div className=" flex-grow">
        <div className="container mx-auto  max-w-screen-xl  ">
          <div className="lg:mt-32 md:w-128  md:mx-auto mt-16 mx-4">
            <ResetPasswordForm />
          </div>
        </div>
      </div>

      <AuthFooter />
    </div>
  );
};

export default ResetPassword;
